import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delay` ms: the returned value only updates once
 * `value` has stopped changing for `delay`. Each change resets the timer, so
 * rapid updates (e.g. keystrokes) collapse into a single trailing update.
 */
export const useDebouncedValue = <T>(value: T, delay: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};
